if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.zoomControls = this.querySelector('[data-panzoom-controls]');
        this.zoomInButton = this.querySelector('[data-panzoom-action="in"]');
        this.zoomOutButton = this.querySelector('[data-panzoom-action="out"]');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.zoomControls?.addEventListener('click', this.onZoomControlClick.bind(this));
        this.querySelectorAll('[data-panzoom-stage], [data-panzoom-controls]').forEach((element) => {
          element.addEventListener('pointerup', (event) => event.stopPropagation());
        });
      }

      hide() {
        this.disposePanzoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        if (!mediaId) return;

        this.disposePanzoom();
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = Math.max(0, (activeMedia.clientWidth - container.clientWidth) / 2);

        this.initializePanzoom(activeMedia);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      initializePanzoom(activeMedia) {
        const image = activeMedia.matches('[data-panzoom-stage]')
          ? activeMedia.querySelector('[data-panzoom-image]')
          : null;

        if (!image || typeof window.panzoom !== 'function') {
          if (this.zoomControls) this.zoomControls.hidden = true;
          return;
        }

        this.activeZoomStage = activeMedia;
        this.activeZoomImage = image;
        this.panzoomInstance = window.panzoom(image, {
          minZoom: 1,
          maxZoom: 4,
          bounds: true,
          boundsPadding: 0.05,
          smoothScroll: false,
          transformOrigin: { x: 0.5, y: 0.5 },
          filterKey: () => true,
        });

        this.panzoomInstance.on('transform', () => this.updateZoomControls());
        this.panzoomInstance.on('panstart', () => activeMedia.classList.add('is-panning'));
        this.panzoomInstance.on('panend', () => activeMedia.classList.remove('is-panning'));

        this.zoomControls.hidden = false;
        this.updateZoomControls();
      }

      onZoomControlClick(event) {
        const button = event.target.closest('[data-panzoom-action]');
        if (!button || !this.panzoomInstance || !this.activeZoomStage) return;

        const currentScale = this.panzoomInstance.getTransform().scale;
        const targetScale = button.dataset.panzoomAction === 'in'
          ? Math.min(4, currentScale * 1.4)
          : Math.max(1, currentScale / 1.4);
        const centerX = this.activeZoomStage.clientWidth / 2;
        const centerY = this.activeZoomStage.clientHeight / 2;
        const scaleMultiplier = targetScale / currentScale;

        if (this.prefersReducedMotion.matches) {
          this.panzoomInstance.zoomTo(centerX, centerY, scaleMultiplier);
        } else {
          this.panzoomInstance.smoothZoom(centerX, centerY, scaleMultiplier);
        }
      }

      updateZoomControls() {
        if (!this.panzoomInstance) return;

        const scale = this.panzoomInstance.getTransform().scale;
        this.zoomInButton.disabled = scale >= 3.99;
        this.zoomOutButton.disabled = scale <= 1.01;
        this.activeZoomStage.classList.toggle('is-zoomed', scale > 1.01);
      }

      disposePanzoom() {
        if (this.panzoomInstance) {
          this.panzoomInstance.off();
          this.panzoomInstance.dispose();
          this.panzoomInstance = null;
        }

        if (this.activeZoomImage) {
          this.activeZoomImage.style.removeProperty('transform');
          this.activeZoomImage.style.removeProperty('transform-origin');
        }

        this.activeZoomStage?.classList.remove('is-panning', 'is-zoomed');
        this.activeZoomStage = null;
        this.activeZoomImage = null;
        if (this.zoomControls) this.zoomControls.hidden = true;
      }
    }
  );
}
